export default __webpack_public_path__ + "static/media/fleet-card.d9eb3fe0.svg";